export { ScrollimateDirective } from './src/ng2-scrollimate.directive';
export { ScrollimateService } from './src/ng2-scrollimate.service';
export { Ng2ScrollimateModule } from './src/ng2-scrollimate.module';
//# sourceMappingURL=ng2-scrollimate.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-scrollimate/dist/ng2-scrollimate.js
// module id = ./node_modules/ng2-scrollimate/dist/ng2-scrollimate.js
// module chunks = vendor